var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6665 0.166992C10.3306 0.166992 10.9165 0.75293 10.9165 1.41699V2.12012C13.729 2.58887 15.9165 5.0498 15.9165 7.97949V9.30762C15.9165 11.0654 16.5024 12.7842 17.5962 14.1904L18.1821 14.8936C18.4165 15.2061 18.4556 15.5967 18.2993 15.9092C18.1431 16.2217 17.8306 16.417 17.479 16.417H1.854C1.46338 16.417 1.15088 16.2217 0.994629 15.9092C0.838379 15.5967 0.877441 15.2061 1.11182 14.8936L1.69775 14.1904C2.7915 12.7842 3.4165 11.0654 3.4165 9.30762V7.97949C3.4165 5.0498 5.56494 2.58887 8.4165 2.12012V1.41699C8.4165 0.75293 8.96338 0.166992 9.6665 0.166992ZM9.6665 3.91699H9.354C7.08838 3.91699 5.2915 5.75293 5.2915 7.97949V9.30762C5.2915 11.1826 4.74463 12.9795 3.729 14.542H15.5649C14.5493 12.9795 14.0415 11.1826 14.0415 9.30762V7.97949C14.0415 5.75293 12.2056 3.91699 9.979 3.91699H9.6665ZM12.1665 17.667C12.1665 18.3311 11.8931 18.9951 11.4243 19.4639C10.9556 19.9326 10.3306 20.167 9.6665 20.167C9.00244 20.167 8.33838 19.9326 7.86963 19.4639C7.40088 18.9951 7.1665 18.3311 7.1665 17.667H9.6665H12.1665Z",
    fill: "#D8D8D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellDark);
export default __webpack_public_path__ + "static/media/bell_dark.1b0d9178f296557cd0b58fc8e6bb877f.svg";
export { ForwardRef as ReactComponent };